<main
  class="flex page-height items-center justify-center px-6 py-24 sm:py-32 lg:px-8 text-white"
>
  <div class="text-center">
    <p class="text-xl font-semibold"></p>
    <h1 class="mt-4 text-3xl font-medium tracking-tight sm:text-5xl">
      404 Page not found
    </h1>
    <p class="mt-6 text-sm tablet-min:text-base leading-7 text-gray-400">
      Sorry, we couldn’t find the page you’re looking for.
    </p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <a
        href="/"
        class="rounded-md bg-custom-orange px-3.5 py-2.5 text-sm text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >Go back to Bids & Offers</a
      >
    </div>
  </div>
</main>
